module.exports = __webpack_public_path__ + "image/header-phone.png";